import React from 'react';
import FeatureUnavailable from '../components/FeatureUnavailable';

/**
 * Investor Outreach Page
 * 
 * This service is currently in development.
 * Display a "Coming Soon" page until the service is ready.
 */
const InvestorOutreach: React.FC = () => {
  return (
    <FeatureUnavailable
      title="Coming Soon"
      subtitle="Investor Outreach"
      description="A social networking platform connecting individuals on their investment and entrepreneurship journeys with experienced professionals and mentors. Build meaningful connections and accelerate your growth through community-driven learning."
      featureType="service"
      serviceName="Investor Outreach"
      logoSrc="/mono-investor-outreach.png"
      showBackButton={true}
      backPath="/work"
      showHomeLink={true}
      showContactOption={true}
    />
  );
};

export default InvestorOutreach;
